import { render, staticRenderFns } from "./SolisticViewCard.vue?vue&type=template&id=58ad7123&scoped=true&"
import script from "./SolisticViewCard.vue?vue&type=script&lang=js&"
export * from "./SolisticViewCard.vue?vue&type=script&lang=js&"
import style0 from "./SolisticViewCard.vue?vue&type=style&index=0&id=58ad7123&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ad7123",
  null
  
)

export default component.exports